import { Station } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { ValidateAndUploadView } from '../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { CreateSchedulesPreview } from '../common/CreateSchedulesPreview';

export function AudioSchedulesPlkUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.plk']}
      validateFn={(file: File) =>
        apiClient.audit.plkParse({
          stationId: station.id,
          file: file!,
        })
      }
      importFn={(file, data) =>
        apiClient.audit.schedulesCreate({
          stationId: station.id,
          data,
        })
      }
      renderPreview={(data) => <CreateSchedulesPreview data={data} />}
    />
  );
}
